export const CLIENT_CONFIG_RECEIVED = "CLIENT_CONFIG_RECEIVED";
